<template>
    <tr>
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="'pvrCheckbox'+pvr.id"
                 :value="pvr.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="'pvrCheckbox'+pvr.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td class="first_data" data-th="Název"><strong>{{ pvr.name }}</strong></td>
        <td data-th="Stav">{{ stateString() }}</td>
        <td data-th="Kanál">
          <entity-link :id="pvr.id_channel" type="channel">{{ pvr.name_channel }}</entity-link> <span class="stitek hd" v-if="pvr.channel_hd">HD</span>
        </td>
        <td data-th="Nahráno na">
          <entity-link :id="pvr.id_device" type="device">{{ pvr.name_device }}</entity-link>
        </td>
        <td data-th="Uživatelské profily">
          <span v-for="(profile, index) in pvr.profiles"><span v-if="index !== 0">, </span>
          <entity-link :id="profile.id" type="subscriberProfile">{{ profile.name }}</entity-link>
          </span>
        </td>
        <td data-th="Délka">{{ $_formatMinutesToString(pvr.length / 60) }}</td>
        <td data-th="Datum vysílání" v-html="$_date_formatFull(pvr.timestamp_broadcast_start)"></td>
        <td data-th="Datum nahrání" v-html="$_date_formatFull(pvr.timestamp_created)"></td>
        <td data-th="Datum expirace" v-html="$_date_formatFull(pvr.timestamp_expiration)"></td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a v-if="isDeletable" class="btn btn_action btn_delete" @click.stop="onDeletePvr" :title="$gettext('Smazat')">{{ $gettext('Smazat') }}</a>
            </div>
        </td>
    </tr>
</template>

<script>
import EntityLink from "../../../common/EntityLink.vue";

export default {
		name: "PvrRow",
    components: { EntityLink },
		props: {
			pvr: Object,
      selectedEntities: Array,
      isDeletable: Boolean,
		},
        methods: {
            onDeletePvr() {
                this.$emit('deletePvr', this.pvr.id);
            },
          onChange: function (e) {
            this.$emit('input', e)
          },
          stateString() {
            const now = Date.now() / 1000;
            const timeUtc = new Date();
            const expiration = new Date(this.pvr.timestamp_expiration*1000);
            const start = new Date(this.pvr.timestamp_broadcast_start*1000);
            const tomorrow = new Date(timeUtc.getTime() + 24 * 60 * 60 * 1000);
            let translateString;

            if (this.pvr.timestamp_broadcast_end < now) {
              const dayToDelete = Math.ceil((this.pvr.timestamp_expiration - now) / 86400);

              if (expiration.getDate() === timeUtc.getDate() && expiration.getMonth() === timeUtc.getMonth() && expiration.getFullYear() === timeUtc.getFullYear()) {
                translateString = this.$gettext("Dnes bude smazán");
              } else if (expiration.getDate() === tomorrow.getDate() && expiration.getMonth() === tomorrow.getMonth() && expiration.getFullYear() === tomorrow.getFullYear()) {
                translateString = this.$gettext("Zítra bude smazán");
              } else if (dayToDelete >= 2 && dayToDelete <= 4) {
                translateString = this.$gettext("%{days} dny do smazání");
              } else {
                translateString = this.$gettext("%{days} dnů do smazání");
              }
              return this.$gettextInterpolate(translateString, {days: dayToDelete});
            }else if (this.pvr.timestamp_broadcast_start <= now && this.pvr.timestamp_broadcast_end >= now){
              return this.$gettext('Právě se nahrává');
            } else {
              if (start.getDate() === timeUtc.getDate() && start.getMonth() === timeUtc.getMonth() && start.getFullYear() === timeUtc.getFullYear()) {
                translateString = "Nahraje se dnes";
              } else if (start.getDate() === tomorrow.getDate() && start.getMonth() === tomorrow.getMonth() && start.getFullYear() === tomorrow.getFullYear()) {
                translateString = "Nahraje se zítra";
              } else {
                const dayToRecord = Math.ceil((this.pvr.timestamp_broadcast_start - now) / (60 * 60 * 24));

                if (dayToRecord < 5) {
                  translateString = "Nahraje se za %{days} dny";
                } else {
                  translateString = "Nahraje se za %{days} dní";
                }

                return this.$gettextInterpolate(this.$gettext(translateString), { days: dayToRecord });
              }

              return this.$gettext(translateString);
            }
          }
        },
        computed: {
          isChecked() {
            return this.selectedEntities.indexOf(String(this.pvr.id)) > -1
          }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/pvrs/PvrRow.vue